import type { NccaExamCoachSummaryExpanded } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import useSWR from "swr";

const useNccaExamCoachRecommendation = (certificationSlug?: string) => {
	const { isSignedIn } = useAuth();

	const { data, ...rest } = useSWR<NccaExamCoachSummaryExpanded | null>(
		isSignedIn &&
			certificationSlug &&
			`/certifications/${certificationSlug}/exam-coach-recommendation`,
		{
			errorRetryCount: 0,
		},
	);

	const focusCourses = data?.focusCourses ?? [];

	const isCourseRecommended = (courseId: string) =>
		focusCourses.some((course) => course.courseId === courseId);

	return {
		focusCourses,
		isCourseRecommended,
		isLoadingExamCoachRecommendation: rest.isLoading,
		...rest,
	};
};

export default useNccaExamCoachRecommendation;
